import { Idea, IdeaMetric, MetricUnitType } from '@frontend/data-access';
import { IdeaChannelMetrics } from '@frontend/feature-idea-channel';
import { Button, Table } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

export interface IdeaChannelMetricsProps {
  idea: Idea;
  enableManage?: boolean;
}

export function IdeaDetailMetrics({
  idea,
  enableManage = false,
}: IdeaChannelMetricsProps) {
  const { t } = useTranslation('common');
  const [isMetricsModalOpen, setIsMetricsModalOpen] = useState(false);

  const columns = [
    {
      title: t('metric'),
      dataIndex: ['metric', 'name'],
      key: 'name',
    },
    {
      title: t('target'),
      dataIndex: 'target',
      key: 'target',
      render: (_: unknown, record: IdeaMetric) => {
        const isQualitative =
          record.metric?.unit?.type === MetricUnitType.QUALITATIVE;
        return (
          <span>
            {record.target || '-'}{' '}
            {record.target &&
              !isQualitative &&
              (record.metric?.unit?.label || '')}
          </span>
        );
      },
    },
    {
      title: t('actual'),
      dataIndex: 'result',
      key: 'result',
      render: (_: unknown, record: IdeaMetric) => {
        const isQualitative =
          record.metric?.unit?.type === MetricUnitType.QUALITATIVE;
        return (
          <span>
            {record.result || '-'}{' '}
            {record.result &&
              !isQualitative &&
              (record.metric?.unit?.label || '')}
          </span>
        );
      },
    },
  ];

  const handleManageMetrics = () => {
    setIsMetricsModalOpen(true);
  };

  const handleMetricsModalClose = () => {
    setIsMetricsModalOpen(false);
  };

  return (
    <div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <div className="text-gray-700 text-sm font-normal">
            {t('idea_metrics')}
          </div>
          {enableManage && (
            <Button
              type="link"
              size="small"
              onClick={handleManageMetrics}
              data-test="metrics-manage-btn"
            >
              {t('manage')}
            </Button>
          )}
        </div>
        <div>
          <Table
            bordered
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={idea.metrics}
            pagination={false}
          />
        </div>
      </div>
      <IdeaChannelMetrics
        isOpen={isMetricsModalOpen}
        onClose={handleMetricsModalClose}
        selectedIdea={idea}
        platformType="admin"
      />
    </div>
  );
}

export default IdeaDetailMetrics;
